import { User } from 'framework/users'
import { useNotification, useUserSession } from 'hooks'
import type { FC } from 'react'
import { UserService } from 'modules/users/services'
import { useState, useEffect } from 'react'

import type { UserChangeDataProps } from '.'
import UserSubscriptions from "../../components/user-subscriptions/user-subscriptions";

const UserSubscription: FC<UserChangeDataProps> = () => {
  const { user } = useUserSession()

  const [subscriptions, setSubscriptions] = useState<any>([])

  useEffect(() => {
    const userService = new UserService(user as unknown as User)
    userService.getSubscriptions(user.id).then(({data}: any) => setSubscriptions(data))
  }, [])

  return (
    <>
      <UserSubscriptions data={subscriptions} />
    </>
  )
}

export default UserSubscription
